/**
 * Ленивая загрузка сцены «Объём».
 *
 * Сцена нужна не каждому посетителю (большинству хватает карты), а тянет за
 * собой заметный кусок кода. Поэтому она грузится по требованию — так же, как
 * «Объём 3D» и сама библиотека карты. Отдельной страницей делать не стали:
 * повторный холодный старт и повторная загрузка venue.json стоят дороже, чем
 * один ленивый чанк, а состояние (цель, язык, маршрут) при этом сохраняется.
 */
import { tr } from '@app/i18n'
import type { ComponentType } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { importChunk } from '../lazy-retry'

let cached: ComponentType | null = null

/** Заранее подтянуть чанк — вызывается при наведении на кнопку «Объём». */
export function prefetchIso(): void {
  if (cached) return
  void importChunk(() => import('./iso-view'))
    .then((m) => {
      cached = m.IsoView
    })
    .catch(() => {
      // не удалось — попробуем ещё раз при открытии
    })
}

export function IsoLazy() {
  // Ленивый инициализатор ОБЯЗАТЕЛЕН: useState(cached) вызвал бы компонент как
  // функцию-инициализатор, в состояние попал бы результат его вызова (объект
  // JSX), и рендер падал с «createElementNS: [object Object]».
  const [View, setView] = useState<ComponentType | null>(() => cached)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (View) return
    let alive = true
    void importChunk(() => import('./iso-view'))
      .then((m) => {
        cached = m.IsoView
        if (alive) setView(() => m.IsoView)
      })
      .catch(() => {
        if (alive) setFailed(true)
      })
    return () => {
      alive = false
    }
  }, [View])

  if (failed) return <p class="iso-note">{tr('volume3d.failed')}</p>
  if (!View) return <div class="iso-root" aria-busy="true" />
  return <View />
}
